export default __webpack_public_path__ + "static/media/hh.0b1bbfee.jpeg";